/**
 * @desc: - 挂件- 带图标，文字，跳转地址
 * @param  {[STRING]} className：   [icon class]
 * @param  {[STRING]} text:         [显示文字]
 * @param  {[STRING]} url:          [跳转地址]
 * @author: jet
 */
import React from 'react';

export class AffixNewLinkText extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {className, text, url, target} = this.props;
    return (
      <li>
        <b className={className=="ic-xy"?"new":null}></b>
        <a href={url} target={target}>
          <i className={'icon ' + className}></i><span>{text}</span>
        </a>
      </li>
    );
  }
}

export class AffixNewLinkQrcode extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      display:false
    }
    this.showQr = this.showQr.bind(this)
    this.hideQr = this.hideQr.bind(this)
  }
  showQr(){
    this.setState({
      display:true
    })
  }
  hideQr(){
    this.setState({
      display:false
    })
  }
  render() {
    const {className, text, url, src} = this.props;
    return (
      <li onMouseOver={this.showQr} onMouseOut = {this.hideQr}>
        <a href={url} target="_blank">
          <i className={'icon ' + className}></i><span>{text}</span>
        </a>
        <div className="phoneCode" style={{"display":this.state.display?"block":"none"}}>
          {
            src ? <img src={src} /> : null
          }
        </div>
      </li>
    );
  }
}

export class AffixNewLinkHangUp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      display:false
    }
    this.showHangUp = this.showHangUp.bind(this)
    this.hideHangUp = this.hideHangUp.bind(this)
  }
  showHangUp(){
    if(this.timer){clearTimeout(this.timer)}
    if(this.timer1){clearTimeout(this.timer1)}
    this.timer1 = setTimeout(()=>{
    this.setState({
      display:true
    })
    },101)
  }
  componentWillUnmount(){
    if(this.timer){clearTimeout(this.timer)}
    if(this.timer1){clearTimeout(this.timer1)}
  }
  hideHangUp(){
    if(this.timer){clearTimeout(this.timer)}
    if(this.timer1){clearTimeout(this.timer1)}
    this.timer = setTimeout(()=>{
      this.setState({
        display:false
      })
    },100)
    
  }
  render() {
    const {className, text, url, src, readme} = this.props;
    return (
      <li onMouseOver={this.showHangUp} onMouseOut = {this.hideHangUp}>
        <b className={className=="ic-hangUp"?"new":null}></b>
        <a href="javascript:;" target="_blank">
          <i className={'icon ' + className}></i><span>{text}</span>
        </a>
        <div className="hangUp"  onMouseOver={this.showHangUp}  onMouseOut = {this.hideHangUp} style={{"display":this.state.display?"block":"none"}}>
          <h3>自动投注挂机软件 <a href={readme} target="_blank" className="tips">使用说明</a></h3>
          <ul>
            <li>
              <h4>电脑版下载</h4>
              <p>推荐使用Win7以上系统<br/>
WinXP用户请百度安裝.net3.5</p>
              <p className="pc-icon"></p>
              <a href={src} target="_blank">高速下载</a>
            </li>
            <li>
              <h4>手机版下载</h4>
              <p>适用苹果/安卓系统</p>
              <p className="hangUp-qr">
                <img src={url} />
              </p>
              <p>推荐使用扫码工具扫一扫下载</p>
            </li>
            <li className="border"></li>
          </ul>
        </div>
      </li>
    );
  }
}